import React from 'react';
import { Play, AlertTriangle } from 'lucide-react';

const IntroScreen = ({ onStart }) => (
  <div className="intro-mobile-first">
    <div className="intro-hero-bg" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/p1.jpeg)` }} />
    <div className="intro-hero-overlay" />

    <div className="intro-content">
      <div className="vibe-tag mb-4" style={{ background: '#facc15', color: '#000', border: 'none', margin: '0 auto', display: 'inline-flex' }}>
        <AlertTriangle size={14} />
        <span>KALESHI ROAST</span>
      </div>

      <h1 className="intro-hero-title">
        HAPPY<br />
        BDAY<br />
        <span style={{ color: '#facc15' }}>BUDDHE!</span>
      </h1>

      <p className="intro-hero-sub">
        "Barson pehle hi nikal chuka h, to birthday wala natak ye kyon hai bhai?" 😂
      </p>

      <button className="vibe-btn pulse-btn" onClick={onStart}>
        <Play size={20} fill="currentColor" />
        START ROAST
      </button>
    </div>
  </div>
);

export default IntroScreen;
